// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"9042bbdd","311":"acef1dab"}[chunkId] + ".chunk.js";
};